import { render, staticRenderFns } from "./M2hBrowse.vue?vue&type=template&id=253ad838&scoped=true&"
import script from "./M2hBrowse.vue?vue&type=script&lang=js&"
export * from "./M2hBrowse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253ad838",
  null
  
)

export default component.exports